<template lang="pug">
thead.show--bigScreens
  tr(v-if="type=='latestArticlesByPartner'")
    th.tableTop10-1.text--left.color--greyCharcoal30 {{headerText.number}}
    th.tableTop10-2.text--left.color--greyCharcoal30 {{headerText.title}}
    th.tableTop10-3.text--center.color--greyCharcoal30.tableTop-category(@click="sortByType('category')")
      span.text--14 {{headerText.category}}
      i.tableTop10-arrowIcon.icon-arrow.icon-category
    th.tableTop10-6.text--center.color--greyCharcoal30.tableTop-updatedAt(@click="sortByType('updatedAt')")
      span.text--14 {{headerText.updatedAt}}
      i.tableTop10-arrowIcon.icon-arrow.icon-updatedAt
  tr(v-else)
    th.tableTop10-1.text--left.color--greyCharcoal30 {{headerText.number}}
    th.tableTop10-2.text--left.color--greyCharcoal30 {{headerText.title}}
    th.tableTop10-3.text--center.color--greyCharcoal30.tableTop-category(@click="sortByType('category')")
      span.text--14 {{headerText.category}}
      i(v-if='sortable').tableTop10-arrowIcon.icon-arrow.icon-category
    th.tableTop10-4.text--center.color--greyCharcoal30.tableTop-url(@click="sortByType('url')")
      span.text--14 {{headerText.link}}
      i(v-if='sortable').tableTop10-arrowIcon.icon-arrow.icon-url
    th.tableTop10-5.text--center.color--greyCharcoal30.tableTop-reporterCount(@click="sortByType('reporterCount')")
      span.text--14 {{headerText.amount}}
      i(v-if='sortable').tableTop10-arrowIcon.icon-arrow.icon-reporterCount
    th.tableTop10-6.text--center.color--greyCharcoal30.tableTop-followerCount(@click="sortByType('followerCount')")
      span.text--14 {{headerText.bar}}
      i(v-if='sortable').tableTop10-arrowIcon.icon-arrow.icon-followerCount
</template>

<script>
import { disableSort, initCurrentSortByQueryStr } from '@/plugins/tool.js';
import { setGtag } from '@/plugins/gtag.js';

export default {
  props: {
    headerText: Object,
    type: String,
    sortable: Boolean
  },
  data() {
    return {
      currentSort: null
    };
  },
  mounted() {
    this.currentSort = initCurrentSortByQueryStr(
      this.$route.query.params,
      this.type
    );
  },
  methods: {
    sortByType(sortType) {
      if (!this.sortable) return;
      const data = {
        type: sortType,
        direction: -1
      };
      if (this.currentSort === null) {
        this.currentSort = data;
      } else if (this.currentSort.type === data.type) {
        switch (this.currentSort.direction) {
          case 0:
            this.currentSort.direction = -1;
            break;
          case -1:
            this.currentSort.direction = 1;
            break;
          default:
            this.currentSort.direction = 0;
        }
      } else {
        disableSort(this.currentSort.type);
        this.currentSort = data;
      }
      this.$emit('sortByType', this.currentSort);
      setGtag(
        'click',
        '已查核',
        'sort',
        sortType,
        this.$route.query.type !== 'verified'
      );
    }
  }
};
</script>
